export default __webpack_public_path__ + "static/media/facebook-icon.a1979e73.png";